export var ANDROID_RGXP = /Android|BlackBerry/i;
export var IOS_RGXP = /iPhone|iPad|iPod/i;
export var WIN_PHONE_RGXP = /Windows Phone/i;
export var IE_RGXP = /MSIE|Trident/i;
export var WEB_OS_RGXP = /webOS/i;
export var isAndroid = function isAndroid(userAgent) {
  return !!userAgent.match(ANDROID_RGXP);
};
export var isTablet = function isTablet(userAgent) {
  return !!userAgent.match(/iPad/i);
};
export var isIOS = function isIOS(userAgent) {
  return !!userAgent.match(IOS_RGXP) || isTablet(userAgent);
};
export var isIE = function isIE(userAgent) {
  return !!userAgent.match(IE_RGXP);
};
export var isWebOS = function isWebOS(userAgent) {
  return !!userAgent.match(WEB_OS_RGXP);
};
export var isWindowsPhone = function isWindowsPhone(userAgent) {
  return !!userAgent.match(WIN_PHONE_RGXP);
};
export var checkIsMobile = function checkIsMobile(userAgent) {
  return isAndroid(userAgent) || isIOS(userAgent) || isWebOS(userAgent) || isWindowsPhone(userAgent);
};
export var getDeviceType = function getDeviceType() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return {
    isAndroid: isAndroid(userAgent),
    isIOS: isIOS(userAgent),
    isIE: isIE(userAgent),
    isTablet: isTablet(userAgent),
    isMobile: checkIsMobile(userAgent)
  };
};
export var getDeviceTypeFromRequest = function getDeviceTypeFromRequest(req) {
  var UAHeader = req.headers['user-agent'];
  return getDeviceType(UAHeader);
};